import React, { useEffect, useState } from "react";
import { ToastMessage } from "../../../global/ToastMessage";
import { FProveedorUsuarioStyle } from "./styles";
import { useFormik } from "formik";
import TextField from "@material-ui/core/TextField";
import { Button, Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  altaProveedorUsuarioAction,
  obtnerProveedorUsuarioByIdAction,
} from "./../../../ducks/porveedorUsuarioDuck";
import HeaderModal from "../../../global/headerModal";
import BackDrop from "./../../../global/BackDrop";
import ModalBase from "./../../../global/ModalBase";
import * as yup from "yup";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const validationSchema = yup.object({
  email: yup
    .string("Ingresa un email")
    .email("Email invalido")
    .required("Email es requerido"),
  nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  apellidoPaterno: yup
    .string("Ingresa un apellido paterno")
    .required("Ingresa un apellido paterno"),
  apellidoMaterno: yup.string("Ingresa un apellido materno").optional(),
  telefono: yup
    .string("Ingresa un telefono")
    .matches(phoneRegExp, "Numero de telefono invalido")
    .required("Telefono es requerido"),
});

const FProveedorUsuarios = (props) => {
  const {
    open = true,
    setOpen = () => {},
    rowData = {},
    editar = false,
    setEditar = () => {},
  } = props;

  const InitalValues = {
    email: "",
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    telefono: "",
  };
  const idProveedor = useSelector(store => store.proveedoresUsuarios.idProveedor);
  const dispatch = useDispatch();
  const classes = FProveedorUsuarioStyle();
  const [isLoad, setIsLoad] = useState(false);

  const formik = useFormik({
    initialValues: InitalValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      (editar) ? onUpdate(values)  : onSave(values)
    },
  });

  const onUpdate = (values) =>{
    setIsLoad(true);
    let proveedor = {
      IdProveedor: idProveedor,
      Email: values.email,
      Nombre: values.nombre,
      ApellidoPaterno: values.apellidoPaterno,
      ApellidoMaterno: values.apellidoMaterno,
      Telefono: values.telefono,
    };
    dispatch(altaProveedorUsuarioAction(proveedor)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break;
      }
      setIsLoad(false);
    });
  }
  const onSave = (values) =>{
    setIsLoad(true);
    let proveedor = {
      IdProveedor: idProveedor,
      Email: values.email,
      Nombre: values.nombre,
      ApellidoPaterno: values.apellidoPaterno,
      ApellidoMaterno: values.apellidoMaterno,
      Telefono: values.telefono,
    };
    dispatch(altaProveedorUsuarioAction(proveedor)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break;
      }
      setIsLoad(false);
    });
  }
  useEffect(() => {
    const buscarById = () => {
      setIsLoad(true);
      dispatch(obtnerProveedorUsuarioByIdAction(rowData.IdUsuario)).then(
        (Response) => {
          formik.setFieldValue("descripcion", Response.Descripcion);
          formik.setFieldValue("nombre", Response.Nombre);
          formik.setFieldValue("precioNeto", Response.PrecioPublico);
          formik.setFieldValue("precioPublico", Response.PrecioPublico);
          formik.setFieldValue("dias", Response.Dias);
          formik.setFieldValue("noches", Response.Noches);
          formik.setFieldValue("numeroPersonas", Response.Personas);
          setIsLoad(false);
        }
      );
    };
    if (editar) buscarById();
    return () => {
      LimpiarForm();
    };
  }, [editar, rowData.IdPaquete, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const LimpiarForm = () => {
    formik.resetForm(InitalValues);
  };
  const handleClose = () => {
    setOpen(!open);
    setEditar(false);
    LimpiarForm();
  };
  
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        handleClose={handleClose}
        titulo={editar ? "Actuliza usuario" : "Nuevo usuario"}
      />
      <form onSubmit={formik.handleSubmit}>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={4}>
            <TextField
              required
              id="input-Nombre"
              label="Nombre"
              type="text"
              variant="outlined"
              name="nombre"
              value={formik.values.nombre}
              onChange={formik.handleChange}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={formik.touched.nombre && formik.errors.nombre}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-apPaterno"
              label="Apellido paterno"
              type="text"
              variant="outlined"
              name="apellidoPaterno"
              value={formik.values.apellidoPaterno}
              onChange={formik.handleChange}
              error={
                formik.touched.apellidoPaterno &&
                Boolean(formik.errors.apellidoPaterno)
              }
              helperText={
                formik.touched.apellidoPaterno && formik.errors.apellidoPaterno
              }
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-apMaterno"
              label="Apellido materno"
              type="text"
              variant="outlined"
              name="apellidoMaterno"
              value={formik.values.apellidoMaterno}
              onChange={formik.handleChange}
              error={
                formik.touched.apellidoMaterno &&
                Boolean(formik.errors.apellidoMaterno)
              }
              helperText={
                formik.touched.apellidoMaterno && formik.errors.apellidoMaterno
              }
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-email"
              label="Correo"
              type="text"
              variant="outlined"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-telfono"
              label="Teléfono"
              type="text"
              variant="outlined"
              name="telefono"
              value={formik.values.telefono}
              onChange={formik.handleChange}
              error={formik.touched.telefono && Boolean(formik.errors.telefono)}
              helperText={formik.touched.telefono && formik.errors.telefono}
              className={classes.textField}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.modalBoton}
            >
              {editar ? "Actulizar" : "Guardar"}
            </Button>
          </Grid>
        </Grid>
        <BackDrop open={isLoad} />
      </form>
    </ModalBase>
  );
};
export default FProveedorUsuarios;
